class RequestWalletUpdate {
	static protocol = {}

	constructor() {}
}

export default RequestWalletUpdate
